module.exports = __webpack_public_path__ + "img/gj-banner-info.e3253837.png";